import Vue from 'vue'
import App from './App.vue'
import router from './router'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// 导入ant-design-vue
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import { Form, message, notification } from 'ant-design-vue';
Vue.prototype.$form = Form
Vue.prototype.$message = message
Vue.prototype.$notification = notification

// 导入字体图标库
import '@/assets/font/iconfont.css'

import VueSplide from '@splidejs/vue-splide'

import axios from 'axios'
import VueAxios from 'vue-axios'

import i18n from './common/i18n/i18n.js'

import './assets/css/common.css'

Vue.use(BootstrapVue).use(IconsPlugin).use(VueAxios, axios).use(VueSplide).use(Antd)

Vue.prototype.$axios = axios
Vue.config.productionTip = false

// 引用bus
import bus from '@/utils/bus'
Vue.prototype.$bus = bus

// 导入 vuex
import store from '@/store/index.js'

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
